import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { WooTabsComponent } from '@navigation/woo-tabs/woo-tabs.component';
import { WooTableComponent } from '@presentational/woo-table/woo-table.component';
import { WooMaxValidator } from '@scripts/woo_components.module/directives/woo-max-validator.directive';
import { WooMinValidator } from '@scripts/woo_components.module/directives/woo-min-validator.directive';
import { WooPercentFormatter } from '@scripts/woo_components.module/directives/woo-percent-formatter.directive';
import { WooComponentsModule } from '@scripts/woo_components.module/module';
import ScrollToDirective from '@src/shared/directives/scroll-into-view.directive';
import { DotLoader } from '@src/shared/feedback/loader/dot-loader.component';
import { WooTabComponent } from '@src/shared/navigation/woo-tabs/woo-tab/woo-tab.component';
import { SortPipe } from '@src/shared/pipes/sort.pipe';
import { WooColumnParent } from '@src/shared/presentational/woo-table/woo-table-column/column-parrent.component';
import { WooTableColumn } from '@src/shared/presentational/woo-table/woo-table-column/woo-table-column.component';
import { AdvancedTargetGroupCategoryForm } from './components/products_page/advanced_target_groups/advanced-target-group-category-form.component';
import { AdvancedTargetGroupForm } from './components/products_page/advanced_target_groups/advanced-target-group-form.component';
import { EditAdvancedTargetGroup } from './components/products_page/advanced_target_groups/edit-advanced-target-groups.component';
import { ManageAdvancedTargetGroups } from './components/products_page/advanced_target_groups/manage-advanced-target-groups.component';
import { ManageAgWithdrawalLimits } from './components/products_page/ag_withdrawal_limit/manage-ag-withdrawal-limits.component';
import { BehaviorForm } from './components/products_page/behaviors/behavior-form.component';
import { ManageBehaviors } from './components/products_page/behaviors/manage-behaviors.component';
import { ManageCategories } from './components/products_page/categories/manage-categories.component';
import { ManageCompletionRatesEstimates } from './components/products_page/completed_views/manage-completion-rates-estimates.component';
import { ManageDayparts } from './components/products_page/dayparts/manage-dayparts.component';
import { ManageDefaultFrequencyLimits } from './components/products_page/default_frequency_limits/manage-default-frequency-limits.component';
import { DeviceGroupForm } from './components/products_page/device_groups/device-group-form.component';
import { EditDeviceGroup } from './components/products_page/device_groups/edit-device-group.component';
import { ManageDeviceGroups } from './components/products_page/device_groups/manage-device-groups.component';
import { ManageDevices } from './components/products_page/devices/manage-devices.component';
import { ManageFrequencyLimits } from './components/products_page/frequency_limit/manage-frequency-limits.component';
import { ManageGamblingEstimates } from './components/products_page/gambling/manage-gambling-estimates.component';
import { ManageGrossRatingFactor } from './components/products_page/gross_rating_views/manage-gross-rating-factor.component';
import { ManagePauseAdEstimates } from './components/products_page/pause_ad/manage-pause-ad-estimates.component';
import { CalculatePrice } from './components/products_page/pricelists/calculate-price.component';
import { EditOverwrittenPriceRowContainer } from './components/products_page/pricelists/edit-overwritten-price-row-container.component';
import { EditOverwrittenPrice } from './components/products_page/pricelists/edit-overwritten-price.compontent';
import { EditPricelist } from './components/products_page/pricelists/edit-pricelist.component';
import { ManagePriceLists } from '@scripts/product_management.module/components/products_page/pricelists/manage-pricelists/manage-pricelists.component';
import { PriceRowContainer } from './components/products_page/pricelists/price-row-container.component';
import { SelectPricelistForm } from './components/products_page/pricelists/select-pricelist-form.component';
import { ManageProductFormatShares } from './components/products_page/product_formats/manage-product-formats-shares';
import { CreateNewProgramFormat } from './components/products_page/program_formats/create-new-program-format.component';
import { ManageProgramFormats } from '@scripts/product_management.module/components/products_page/program_formats/manage-program-formats/manage-program-formats.component';
import { ManageRegions } from './components/products_page/regions/manage-regions.component';
import { ManageTargetGroups } from './components/products_page/target_groups/manage-target-groups.component';
import { ManageUniverse } from './components/products_page/universe/manage-universe.component';
import { EditEstimates } from './components/shared/edit_estimates/edit-estimates.component';
import { PerIdEstimatesInput } from './components/shared/estimate_input/per-id-estimates-input.component';
import { OutstreamEstimatesInput } from './components/shared/outstream_estimates_input/outstream-estimates-input.component';
import { ProductsPageUtilityService } from './components/shared/products-page-utility-service';

@NgModule({
  imports: [
    CommonModule,
    SortPipe,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    WooComponentsModule,
    WooTabsComponent,
    WooTabComponent,
    WooTableComponent,
    WooTableColumn,
    WooColumnParent,
    WooMinValidator,
    WooMaxValidator,
    WooPercentFormatter,
    ManageGrossRatingFactor,
    ScrollToDirective,
    DotLoader,
    WooTableComponent,
    WooTableColumn,
  ],
  declarations: [
    ManageCompletionRatesEstimates,
    EditPricelist,
    AdvancedTargetGroupCategoryForm,
    AdvancedTargetGroupForm,
    BehaviorForm,
    DeviceGroupForm,
    CalculatePrice,
    CreateNewProgramFormat,
    EditAdvancedTargetGroup,
    EditDeviceGroup,
    EditEstimates,
    EditOverwrittenPrice,
    EditOverwrittenPriceRowContainer,
    ManageAdvancedTargetGroups,
    ManageAgWithdrawalLimits,
    ManageBehaviors,
    ManageDayparts,
    ManageDeviceGroups,
    ManageDevices,
    ManageDefaultFrequencyLimits,
    ManageFrequencyLimits,
    ManageGamblingEstimates,
    ManagePauseAdEstimates,
    ManagePriceLists,
    ManageProductFormatShares,
    ManageProgramFormats,
    ManageRegions,
    ManageTargetGroups,
    ManageUniverse,
    ManageCategories,
    OutstreamEstimatesInput,
    PerIdEstimatesInput,
    PriceRowContainer,
    SelectPricelistForm,
  ],
  exports: [EditEstimates, EditAdvancedTargetGroup, EditDeviceGroup, CalculatePrice, ManageCompletionRatesEstimates],
  providers: [ProductsPageUtilityService],
})
export class ProductManagementModule {}
